// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__AVApW","info":"PatientInfo_info__sAZ5o"};